import { render } from "./KreyativSponsorShip.vue?vue&type=template&id=99205c84"
const script = {}

import "./KreyativSponsorShip.vue?vue&type=style&index=0&id=99205c84&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.2.13_webpack@5.88.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__